import { apbApi } from './Base';

export function getModelPortfolios(date: string, pkg: string, configurationDirectory?: string) {
  const path = '/api/v4/client-configuration/model-portfolios';
  const params = { date, pkg, configurationDirectory };
  return apbApi.get(path, { params });
}
